import * as bd from 'react-basic-design';
import { Outlet } from 'react-router-dom';
import { AppbarShell } from './appbar-shell';
import { CSSProperties } from 'react';

export function PublicLayout() {
    const main_style: CSSProperties = { minHeight: 500 };
    return (
        <bd.Flex vertical className="h-100">
            <AppbarShell />

            <main className="content flex-grow-1" style={main_style}>
                <Outlet />
            </main>
        </bd.Flex>
    );
}
